import * as types from "redux/types";


const initialState = {
  priorityList: [
    { value: 'high', label: 'فوری' },
    { value: 'middle', label: 'مهم' },
    { value: 'low', label: 'عادی ' },
    // { value: 'high3', label: 'فوری' },
  ],

  statusList: [
    { value: 'finished', label: 'یا پایان یافته' },
    { value: 'support_waiting', label: 'در انتظار پاسخ پشتیبان' },
    { value: 'customer_waiting', label: 'در انتظار پاسخ مشتری' },
  
  ]
};


const indexReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_SUPPORT: {
      const { prop, value } = payload;
      return {
        ...state,
        [prop]: value,
      };
    }
    default:
      return state;
  }
};



export default indexReducer;
